import { apiClient } from "../services/apiClient";
import { ATP_API_URL } from "../config/apiConfig";

/**
 * Fetch entity list from API with pagination
 * @param {number} pageNumber - Page number (1-based)
 * @param {number} pageSize - Number of items per page
 * @returns {Promise} Response with entity list data and pagination info
 */
export const fetchEntityListAction = async (pageNumber = 1, pageSize = 10) => {
    try {
        const params = {
            pageNumber,
            pageSize
        };

        const response = await apiClient.get(ATP_API_URL.GET_ALL_DATA, { params });

        if (response?.status === 200 && response.data) {
            const responseData = response.data?.data || [];

            // Handle case where pagination is just a number (totalRecords)
            let totalRecords;
            if (typeof response.data.pagination === 'number') {
                totalRecords = response.data.pagination;
            } else {
                const serverPagination = response.data?.pagination || {};
                totalRecords = response.data?.totalRecords ||
                    serverPagination?.totalRecords ||
                    serverPagination?.totalItems ||
                    responseData.length;
            }

            // Calculate pagination based on totalRecords
            const calculatedTotalPages = Math.ceil(totalRecords / pageSize);

            const paginationData = {
                currentPage: pageNumber,
                totalPages: calculatedTotalPages,
                totalItems: totalRecords,
                pageSize: pageSize,
                hasNextPage: pageNumber < calculatedTotalPages,
                hasPreviousPage: pageNumber > 1
            };

            return {
                success: true,
                data: responseData,
                pagination: paginationData,
                message: "Entity list fetched successfully"
            };
        }

        return {
            success: false,
            data: [],
            pagination: {
                currentPage: 1,
                totalPages: 1,
                totalItems: 0,
                pageSize: pageSize,
                hasNextPage: false,
                hasPreviousPage: false
            },
            message: "Failed to fetch entity list"
        };
    } catch (error) {
        return {
            success: false,
            data: [],
            pagination: {
                currentPage: 1,
                totalPages: 1,
                totalItems: 0,
                pageSize: pageSize,
                hasNextPage: false,
                hasPreviousPage: false
            },
            message: error.message || "Failed to fetch entity list",
            error
        };
    }
};